export const DisplayThemes = [
    { id: 'classic', nameKey: 'themes.classic' },
    { id: 'noir', nameKey: 'themes.noir' },
    { id: 'emerald', nameKey: 'themes.emerald' },
    { id: 'minimal', nameKey: 'themes.minimal' }
];

export const ThemePalettes = {
    classic: {
        face: '#0D0E0F',
        faceGlow: 'whitesmoke',
        text: 'whitesmoke',
        hand: '#0D0E0F',
        handAccent: 'whitesmoke',
        marker: '#0D0E0F',
        backgroundSize: '110% 110%',
        backgroundBrightness: 0.5,
        vignette: 0.7,
        faceOpacity: 1,
        glowOpacity: 0.33
    },
    noir: {
        face: '#050505',
        faceGlow: '#8A95A3',
        text: '#F5F7FA',
        hand: '#050505',
        handAccent: '#D7DEE8',
        marker: '#050505',
        backgroundSize: '112% 112%',
        backgroundBrightness: 0.28,
        vignette: 0.82,
        faceOpacity: 1,
        glowOpacity: 0.18
    },
    emerald: {
        face: '#061411',
        faceGlow: '#84F5C2',
        text: '#EAFBF4',
        hand: '#061411',
        handAccent: '#BDF7D8',
        marker: '#061411',
        backgroundSize: '108% 108%',
        backgroundBrightness: 0.42,
        vignette: 0.64,
        faceOpacity: 0.96,
        glowOpacity: 0.28
    },
    minimal: {
        face: '#111111',
        faceGlow: '#F4EFE6',
        text: '#FAF7EF',
        hand: '#111111',
        handAccent: '#FAF7EF',
        marker: '#111111',
        backgroundSize: '100% 100%',
        backgroundBrightness: 0.18,
        vignette: 0.88,
        faceOpacity: 0.9,
        glowOpacity: 0.08
    }
};
